export default class Portal {

    constructor (portal) {
        this.portal = portal;
    }

    //get portal name, if site_name not set then default to computing it from the URL
    getName () {
        // if site_name exists, use that
        if (this.portal.instance.configuration && typeof this.portal.instance.configuration.site_name === "string") {
            return this.portal.instance.configuration.site_name;
        }

        return this.portal.instance.title;
    }

    //check if admin exists in this user's roles for the portal
    isAdmin () {
        return this.portal.roles && this.portal.roles.includes("administrator")
    }

    // check if logo exists for the portal otherwise don't put a logo
    getLogo() {
        return this.portal.instance.files &&
          this.portal.instance.files.logo &&
          // ignore the logo if its the default portal logo
          this.portal.instance.files.logo !== "images/logo-white.png" ?
          this.portal.instance.files.logo : "";
    }

    //prepare data for vue component to use
    prepareModel () {
        return {
            is_admin: this.isAdmin(),
            url: this.portal.instance_name,
            name: this.getName(),
            id: this.portal.instance.id,
            logo: this.getLogo()
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/Portal.js